class StockBranchesService {
  constructor(stockBranchesServiceClient) {
    this._stockBranchesServiceClient = stockBranchesServiceClient;
  }

  fetchStockAvailabilityBranches = async (productCode, quantity, unitOfMeasure, location) => {
    const data = await this._stockBranchesServiceClient.fetchStockAvailabilityBranches(productCode, quantity, unitOfMeasure, location);

    const branches = data ? data : [];

    const result = {};
    for (let i = 0; i < branches.length; i++) {
      const entry = {};
      entry["branch"] = branches[i].branch;
      entry["stockAvailability"] = branches[i].stockAvailability;
      result[i] = entry;
    }
    return result;
  };

}

export default StockBranchesService;